module.exports = __webpack_public_path__ + "static/media/oberflex-sycomore-1200x2490.597ac6f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-sycomore-1200x2490.jpg
// module id = 1056
// module chunks = 37